<template>
  <public-layout>
    <section class="hero hero-header-1">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">Free Resources</p>
              <p class="product-description">
                Collection of innovative educational material including printables, activities, videos, apps and much more.
               Each resource is curated by our Finnish pedagogical experts and supports the Fun Learning approach.
                Designed to fuel curiosity in little children and encourage them to explore, create, learn and share.
                 Use them as additional learning resources for your classroom or to support independent learning, to make learning FUN!
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/resources.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="section is-left-aligned">
      <div class="container">
        <div class="columns">
          <div class="column is-3">
            <resource-filters></resource-filters>
          </div>
          <div class="column is-9">
            <Searchbar class="resources-search" @searchStringChanged="onSearchStringChanged"></Searchbar>
            <Loader v-if="isLoading"></Loader>
            <template v-else>
              <div v-for="(resource, index) in resources" :key="`resource-${index}`">
                <ResourceListItem
                  :id="resource.id"
                  :title="resource.title"
                  :description="resource.description"
                  :category="resource.type.name"
                  :categoryImg="resource.type.img"
                  :image="resource.thumb"
                  :tags="resource.subjects"
                  :onClick="loadResource"
                ></ResourceListItem>
              </div>
              <Pagination :current="currentPage" :total="totalPages" @onPageChanged="toPage" v-if="totalPages > 1"></Pagination>
            </template>
          </div>
        </div>
      </div>
    </div>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import ResourceFilters from '@/components/ResourceFilters'
import ResourceListItem from '@/components/ResourceListItem'
import Pagination from '@/components/Pagination'
import Searchbar from '@/components/Searchbar'
import Loader from '@/components/Loader'

import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  components: {
    PublicLayout,
    ResourceFilters,
    ResourceListItem,
    Pagination,
    Searchbar,
    Loader
  },

  watch: {
    '$route.query': 'resetFilters'
  },

  computed: {
    ...mapState('resources', {
      resources: state => state.resources,
      isLoading: state => state.isFetching,
      itemsPerPage: state => state.limit,
      currentPage: state => state.page
    }),

    ...mapGetters('resources', {
      totalPages: 'totalPages'
    })
  },

  methods: {
    ...mapActions('resources', ['fetch', 'setSearchString', 'setPage']),

    loadResource (id) {
      this.$router.push({ name: 'resource', params: { id: id } })
    },

    onSearchStringChanged (searchSting) {
      this.setSearchString(searchSting)
      this.fetch()
    },

    toPage (page) {
      if (page > 0 && page <= this.totalPages) {
        this.setPage(page)
        this.fetch()
      }
    },

    resetFilters () {
      this.$store.commit('resources/resetFilters')
      if (this.$route.query.types) {
        for (let typeId of this.$route.query.types) {
          this.$store.commit('resources/setFilter', { filterGroup: 'types', filterId: parseInt(typeId), checked: true })
        }
      }
      this.fetch()
    }
  },

  created () {
    this.resetFilters()
  }
}
</script>

<style lang="scss">
.testimonies-title {
  color: #0A2239;
  font-size: 2.5rem;
  font-weight: bold;
  line-height: 1.2;
  margin-bottom: 1.125rem;
}

.testimonies-subtitle {
  color: #363636;
  font-size: 1.25rem;
  line-height: 1.6;
}
</style>



// WEBPACK FOOTER //
// src/pages/ResourcesPage.vue